import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import { Grid, InputAdornment, MenuItem, Select, TextField } from '@mui/material';

const RewardSearch = ({ search, setSearch, onSortingChange, sorting }) => {
  return (
    <>
      <Grid container columnSpacing={1}>
        <Grid item xs={8}>
          <TextField
            fullWidth
            placeholder="ค้นหาของรางวัล"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#737373' }} />
                </InputAdornment>
              ),
            }}
            sx={{
              borderRadius: '8px',
              backgroundColor: 'white',

              '& .MuiInputBase-root': {
                fontSize: '1.4rem',
                borderRadius: '8px',
                backgroundColor: 'white',
              },

              '& .MuiInputBase-input': {
                padding: '0 8px',
                height: '25px',
                color: '#000',
                borderLeft: '2px solid #737373',
                margin: '8px 0',
              },

              '& .MuiInputBase-input::placeholder': {
                fontSize: '1.4rem',
              },

              '& .MuiOutlinedInput-notchedOutline': {
                borderRadius: '8px',
                border: '2px solid white',
              },

              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'white',
              },
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <Select
            id="sorting"
            variant="outlined"
            fullWidth
            IconComponent={ExpandMoreIcon}
            value={sorting}
            onChange={onSortingChange}
            sx={{
              fontSize: '1.25rem',
              borderRadius: '8px',
              height: '41px',
              backgroundColor: 'white',

              '& .MuiSelect-select': {
                padding: '0 10px',
                backgroundColor: 'white',
                border: '2px solid white',
                borderRadius: '8px',
              },

              '& .MuiOutlinedInput-input:focus': {
                borderRadius: '8px',
              },

              '& .MuiOutlinedInput-notchedOutline': {
                borderRadius: '8px',
                border: '2px solid white',
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  mt: 1,
                  borderRadius: '10px',

                  '& .MuiMenu-list': {
                    py: 0,
                  },

                  '& .MuiMenuItem-root': {
                    py: '10px',
                    px: 2,
                    minHeight: 48,
                    fontSize: '1.25rem',
                  },

                  '& .MuiButtonBase-root.MuiMenuItem-root.Mui-selected': {
                    backgroundColor: '#005972',
                    color: 'white',
                  },

                  '& .MuiMenuItem-root.Mui-selected': {
                    backgroundColor: '#005972',
                    color: 'white',
                  },
                },
              },
            }}
          >
            <MenuItem value="min-max" sx={{ fontSize: '1.25rem' }}>
              น้อย-มาก
            </MenuItem>
            <MenuItem value="max-min" sx={{ fontSize: '1.25rem' }}>
              มาก-น้อย
            </MenuItem>
          </Select>
        </Grid>
      </Grid>
    </>
  );
};

export default RewardSearch;
